import { styled } from '@linaria/react';

import Item from './Item';
import Fraction from './Fraction';
import InkDeck from './InkDeck';

function GrowItem({
  id,
  flexGrow,
  totalGrow,
  handleIncrement,
  handleDecrement,
}) {
  const isGrown = flexGrow > 0;

  return (
    <Item
      style={{
        flexGrow,
        background: isGrown
          ? 'var(--color-gray-700)'
          : 'var(--color-gray-500)',
      }}
      wrapperStyle={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        // Prevent the doom flicker after transitioning
        willChange: 'transform',
        // Active styles
        transition: 'background 200ms',
        background: isGrown
          ? 'var(--color-gray-300)'
          : 'var(--color-gray-100)',
      }}
      textWrapperStyle={{
        willChange: 'transform',
      }}
    >
      <Wrapper>
        <Header>flex-grow:</Header>
        <Fraction numerator={flexGrow} denominator={totalGrow} />
        <InkDeck
          highlighted={isGrown}
          value={flexGrow}
          handleIncrement={() => handleIncrement(id)}
          handleDecrement={() => handleDecrement(id)}
        />
      </Wrapper>
    </Item>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Header = styled.div`
  font-family: var(--font-family-mono);
  font-size: 0.875rem;
`;

export default GrowItem;
